
import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

export function Navigation() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navItems = [
    { name: 'Home', path: '/' },
    { name: 'Product', path: '/product' },
    { name: 'Check', path: '/check' },
    { name: 'About', path: '/about' },
    { name: 'Blog', path: '/blog' },
    { name: 'Contact', path: '/contact' },
  ];

  const isActive = (path: string) => {
    return location.pathname === path;
  };

  const handleNavClick = () => {
    // Scroll to top when navigating to a new page
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setIsMenuOpen(false);
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-black/50 border-b border-white/10">
      <div className="container mx-auto px-6">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" onClick={handleNavClick} className="flex items-center space-x-3">
            <img 
              src="/logo.png" 
              alt="Driscop Ltd Logo" 
              className="w-8 h-8 object-contain"
            />
            <span 
              className="text-2xl tracking-wider hover:text-blue-400 transition-all duration-300 font-light text-white"
              style={{ fontFamily: "'Share Tech', sans-serif" }}
            >
              Driscop
            </span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            {navItems.map((item) => (
              <Link
                key={item.name}
                to={item.path}
                onClick={handleNavClick}
                className={`text-sm font-light transition-colors whitespace-nowrap cursor-pointer relative group ${
                  isActive(item.path)
                    ? 'text-blue-400'
                    : 'text-white/70 hover:text-blue-400'
                }`}
              >
                {item.name}
                <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-blue-400 transition-all duration-300 group-hover:w-full"></span>
              </Link>
            ))}
            
            <Link
              to="/demo"
              onClick={handleNavClick}
              className="px-6 py-2 rounded-full text-sm font-medium transition-all duration-300 whitespace-nowrap cursor-pointer group bg-white text-black hover:bg-blue-400 hover:text-white"
            >
              Watch Demo
              <span className="ml-2 group-hover:translate-x-1 transition-transform duration-300">→</span>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden p-2 cursor-pointer"
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl text-white`}></i>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-white/20 bg-black/20 backdrop-blur-md">
            <div className="flex flex-col space-y-3">
              {navItems.map((item) => (
                <Link
                  key={item.name}
                  to={item.path}
                  onClick={handleNavClick}
                  className={`text-sm font-medium transition-colors cursor-pointer ${
                    isActive(item.path)
                      ? 'text-cyan-400'
                      : 'text-white/90 hover:text-cyan-400'
                  }`}
                >
                  {item.name}
                </Link>
              ))}
              <Link
                to="/demo"
                onClick={handleNavClick}
                className="bg-blue-600 text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-blue-700 transition-colors text-center cursor-pointer"
              >
                Watch Demo
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
